import request from '@/utils/request';

// 获取用户列表
export var getUserList = function getUserList(data) {
  return request({
    url: '/api/permission/Users',
    method: 'GET',
    data: data
  });
};

// 获取所有用户列表
export var UserListAll = function UserListAll() {
  return request({
    url: '/api/permission/Users/All',
    method: 'GET'
  });
};

// 获取用户下拉框列表(公司+部门+用户)
export var getUserSelector = function getUserSelector() {
  return request({
    url: '/api/permission/Users/Selector',
    method: 'GET'
  });
};

// 新建用户
export var createUser = function createUser(data) {
  return request({
    url: '/api/permission/Users',
    method: 'POST',
    data: data
  });
};

// 修改用户
export var updateUser = function updateUser(data) {
  return request({
    url: "/api/permission/Users/".concat(data.id),
    method: 'PUT',
    data: data
  });
};

// 获取用户信息
export var getUserInfo = function getUserInfo(id) {
  return request({
    url: "/api/permission/Users/".concat(id),
    method: 'GET'
  });
};

// 删除用户
export var delUser = function delUser(id) {
  return request({
    url: "/api/permission/Users/".concat(id),
    method: 'DELETE'
  });
};

// 修改用户密码
export var resetUserPassword = function resetUserPassword(data) {
  return request({
    url: "/api/permission/Users/".concat(data.id, "/Actions/ResetPassword"),
    method: 'POST',
    data: data
  });
};

// 更新用户状态
export var updateUserState = function updateUserState(id) {
  return request({
    url: "/api/permission/Users/".concat(id, "/Actions/State"),
    method: 'PUT'
  });
};

// IM通讯获取用户
export var getImUser = function getImUser(data) {
  return request({
    url: '/api/permission/Users/ImUser',
    method: 'GET',
    data: data
  });
};

// 获取用户下拉框列表
export var getImUserSelector = function getImUserSelector(organizeId, keyword) {
  return request({
    url: "/api/permission/Users/ImUser/Selector/".concat(organizeId),
    method: 'post',
    data: {
      keyword: keyword
    }
  });
};

// 获取用户基本信息
export var getUserInfoList = function getUserInfoList(userId) {
  return request({
    url: '/api/permission/Users/getUserList',
    method: 'post',
    data: {
      userId: userId
    }
  });
};